var days_per_week = '0';

$(document).ready(function(){
  startExcludedDishes();
  startDietaryStyle();
  startWeekNumber()
  startDaysOfTheWeek();
  startDaysPerWeek();
  startMealCount();
  
  onChanges();
  calculatePricePerMeal();
  
});

// on reload functions - start
function startMealCount(){
  // set initial meals count
  var initial_meals_count = $("input[name='mealCount']:checked").val();
  var meals_count_target = $("input[name='properties[meals_count]'][value='"+initial_meals_count+"']")[0]?.id ?? "";
  $("label[for='"+ meals_count_target+"']").click();
  $("input[id='"+ meals_count_target+"']").click();
  setMealsCount();
  
  $("input[name='properties[meals_count]']").change(function(){
    setMealsCount();
    onChanges();
    calculatePricePerMeal();
  });
}

function startDaysPerWeek(){
  var initial_days_per_week = $("input[name='dayPerWeek']:checked").val();
  var days_per_week_target = $("input[name='properties[days_per_week]'][value='"+initial_days_per_week+"']")[0]?.id ?? "";
  $("label[for='"+ days_per_week_target+"']").click();
  $("input[id='"+ days_per_week_target+"']").click();
  setDaysPerWeek();
  
  $("input[name='properties[days_per_week]']").change(function(){
    setDaysPerWeek();
    onChanges();
    calculatePricePerMeal();
  });
}

function startDaysOfTheWeek(){
  $("input[name='day_name_per_week']").change(function(){
    if($("input[name='day_name_per_week']:checked").length > parseInt(days_per_week)){
      this.checked = false
    }
    setDaysOfTheWeek()
    onChanges();
  });
}

function startWeekNumber(){
  var initial_weeks_number = $("input[name='weeksNumber']:checked").val();
  var weeks_number_target = $("input[name='properties[weeks_number]'][value='"+initial_weeks_number+"']")[0].id;
  $("label[for='"+ weeks_number_target+"']").click();
  setWeeksNumber();
  
  $("input[name='properties[weeks_number]']").change(function(){
    setWeeksNumber()
    onChanges();
    calculatePricePerMeal();
  });
}

function startDietaryStyle(){
  $("input[name='properties[dietary_styles]']").change(function(){
    $("input[name='properties[dietary_styles]']").not(this).prop('checked', false); 
    
    var val = $("input[name='properties[dietary_styles]']:checked").val();
    console.log('diety', val , typeof(val))
    $("#dietary_styles_summary").html(typeof(val) != "undefined"? val : "--");

    onChanges();
  });
}

function startExcludedDishes(){
  $("input[name='excluded_dishes']").change(function(){
    var val = [];
    $.each($("input[name='excluded_dishes']:checkbox:checked"), function () {
        val.push($(this).val());
    });
    if(val.length > 2){
       this.checked = false;
       return;
    }
    $("input[name='properties[excluded_dishes]'").val(val.toString());
    $("#excluded_dishes_summary").html(val.join('<br/>'));

    onChanges();
  });
}
// on reload functions - end

// on reload and change functions - start
function setWeeksNumber () {
  var val = $("input[name='properties[weeks_number]']:checked").val();
    var target = $("input[name='weeksNumber'][value='"+val+"']")[0]?.id ?? "";
  
    $("label[for='"+target+"']").click();
    $("input[id='"+target+"']").click();

    var html = val + " Weeks";
    if(val == '1'){
      html = html.replace("Weeks","Week");
    }
    $("#weeks_number_summary").html(html);
}

function setMealsCount () {
    // trigger clicked meals count
    var val = $("input[name='properties[meals_count]']:checked").val();
    var target = $("input[name='mealCount'][value='"+val+"']")[0]?.id ?? "";

    $("label[for='"+target+"']").click();
    $("input[id='"+target+"']").click();

    switch (val){
        case '2':
        case '3':
          checkDaysPerWeek(1);
          break;
        case '4':
        case '5':
          checkDaysPerWeek(2);
          break;
        case '6':
          checkDaysPerWeek(3);
    }
  
    if(typeof val == 'undefined') return;

    // add meals count to summary
    var html = val + " Meals";
    $("#meals_count_summary").html(html);
}

function setDaysPerWeek () {
    var val = $("input[name='properties[days_per_week]']:checked").val();
    var target = $("input[name='dayPerWeek'][value='"+val+"']")[0]?.id ?? "";
  
    $("label[for='"+target+"']").click();
    $("input[id='"+target+"']").click();
    days_per_week = val;

    checkDaysCount(parseInt(val));

    if(typeof val == 'undefined') return;
  
    var html = val + " Days";
    if(val == '1'){
      html = html.replace("Days","Day");
    }
    $("#days_per_week_summary").html(html);
}

function setDaysOfTheWeek (){
    var val = [];
    $.each($("input[name='day_name_per_week']:checkbox:checked"), function () {
        val.push($(this).val());
    });
    $("input[name='properties[day_name_per_week]'").val(val.toString());
    $("#day_name_per_week_summary").html(val.join(', '));
}
// on reload and change functions - end

function checkDaysPerWeek(days_allowed) {
  var days_per_week = parseInt($("input[name='properties[days_per_week]']:checked").val());
  
  if(days_per_week > days_allowed){
    var days_per_week_target = $("input[name='properties[days_per_week]'][value='"+days_allowed+"']")[0]?.id ?? "";
    $("label[for='"+ days_per_week_target+"']").click();
    $("input[id='"+days_per_week_target+"']").click();
  }
  for (var i = 1 ; i <=3; i++){
    $("input[name='properties[days_per_week]'][value='"+i+"']").prop( "disabled", days_allowed < i);
  }
}

function checkDaysCount(days_per_week) {
  if($("input[name='day_name_per_week']:checked").length > days_per_week){
    var days_count = 0;
    $.each($("input[name='day_name_per_week']:checkbox:checked"), function () {
      days_count++;
      if(days_count > days_per_week){
       this.checked = false;
      }
    });

    setDaysOfTheWeek();
  }
}

function onChanges () {
  toggleErrors();
} 

function calculatePricePerMeal () {
  var productPriceStr = $("[data-product-price").html();
  var productPrice = parseFloat(productPriceStr.substring(1)).toFixed(2);

  var mealsCount = Number($("input[name='properties[meals_count]']:checked").val());
  var weeksNumber = Number($("input[name='properties[weeks_number]']:checked").val());

  var pricePerMeal = parseFloat(productPrice / (mealsCount * weeksNumber)).toFixed(2);

  var pricePerMealStr = pricePerMeal.toString() != 'NaN' ? pricePerMeal.toString() : '0.00';
  
  $("#avg-price-meal>div>span").html( productPriceStr.charAt(0) + pricePerMealStr )
}

function toggleErrors () {
  var meals_count = $("input[name='properties[meals_count]']:checked").val();
  var delivery_slot = $("input[name='properties[delivery_slot]']:checked").val();
  var days_per_week = $("input[name='properties[days_per_week]']:checked").val();
  var day_name_per_week_count = $("input[name='day_name_per_week']:checked").length;
  var dietary_styles = $("input[name='properties[dietary_styles]']:checked").val();
  var proc = true;
  var msg = "";
  
  if( isNaN(meals_count) || meals_count <= 0){
    proc = false;
    msg += "<li>Meals per day is missing</li>";
  }
  
  if( isNaN(days_per_week) || days_per_week <= 0){
    proc = false;
    msg += "<li>Days per week is missing</li>";
  }
  
  if(day_name_per_week_count != parseInt(days_per_week)){
    proc = false;
    if(days_per_week == 1){
      var sub_msg = days_per_week + " day";
    }else{
      var sub_msg = days_per_week + " days";
    }
    msg += "<li>You have to pick "+ sub_msg +"</li>";
  }

  if(!proc){
    // show error message
    $("#error-wrapper").removeClass("mp-d-none");
    $(".error-box").html("<ul>" + msg + "</ul>");
    toggleAddToCart("disable");
  }else{
    $("#error-wrapper").addClass("mp-d-none");
    $(".error-box").html('');
    toggleAddToCart("enable"); 
  }
}

function toggleAddToCart (status){
  if(status == "enable"){
    $(".productForm-block").removeClass("mp-d-none");
  }else if(status == "disable"){
    $(".productForm-block").addClass("mp-d-none");
  }
}

